// extracted by mini-css-extract-plugin
export default {"main":"main_iUjq","svgWrapp":"svgWrapp_aUcS"};